import { useGetOrderDetails } from '@/hooks/order/useGetOrderDetails';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { orderDetailsResponseToOrderResumeUi } from '../../mapper';
import { initialState, OrderResumeUi } from './OrderResumeUi';

export function useOrderResumeSectionViewController() {
  const [uiState, setUiState] = useImmer<OrderResumeUi>(initialState);

  const orderDetailId = useParams().orderDetailId ?? '';
  const { data } = useGetOrderDetails(orderDetailId);

  useEffect(() => {
    if (!data) return;
    setUiState(orderDetailsResponseToOrderResumeUi(data));
  }, [data]);

  return {
    uiState,
  };
}
